import React, { FC } from "react";
import COMMON_FIELDS from "../../../../general/constants/commonFields";
import { useTranslation } from "react-i18next";

type ErrorProps = {
	[COMMON_FIELDS.ERROR]?: string;
};

const Error: FC<ErrorProps> = ({ [COMMON_FIELDS.ERROR]: error }) => {
	const { t } = useTranslation();
	return <span>{error || t("err_text_4")}</span>;
};

export default Error;
